export default __webpack_public_path__ + "static/graphic_design_service_features-4c9e916a8fa857195dbf17eae8edeba3.svg";